"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const BlogPostFragment_1 = __importDefault(require("./BlogPostFragment"));
const BlogRecommendationsFragment = (0, graphql_tag_1.default) `
  fragment recommendations on BlogRecommendation {
    id
    title
    variation
    categoryId
    postIds
    link
    quantity
    blogCategoryId
    parentCategoryId
    theme {
      background
      card
    }
    posts {
      ...posts
    }
  }
  ${BlogPostFragment_1.default}
`;
exports.default = BlogRecommendationsFragment;
